import ActionType from './actionType';


export function CreateAccountLoader() {
    return {
        type: ActionType.LoaderAccount
    }
}

export function passCodeLoaderDis() {
    return {
        type: ActionType.passCodeLoader
    }
}
export function LoaderFb() {
    return {
        type: ActionType.LoadingFb
    }
}
export function AuthFbDispatch(payload) {
    return {
        type: ActionType.AuthFacebook,
        payload
    }
}

export function LoaderGoogle() {
    return {
        type: ActionType.LoadingInstant
    }
}
export function AutGoogleDispatch(payload) {
    return {
        type: ActionType.AuthGoogle,
        payload
    }
}

export function LoginError(payload) {
    return {
        type: ActionType.LoginError,
        payload
    }
}
export function AuthSuccess(payload) {
    return {
        type: ActionType.AuthSuccess,
        payload
    }
}
export function errorMessageDispatch(payload) {
    return {
        type: ActionType.PasscodeError,
        payload
    }
}
export function AccountSuccess(payload) {
    return {
        type: ActionType.AuthWithEmail,
        payload
    }
}
export function LoginWithEmailDispatch(payload) {
    return {
        type: ActionType.LoginWithEmail,
        payload
    }
}
export function LoginLoaderDispatch(){
    return{
        type: ActionType.loginLoader
    }
}

export function forgetPasswordSuccessfully(payload){
    return {
        type: ActionType.PasswordRest,
        payload
    }
}

export function profileEidtDispatch(payload){
    return {
        type: ActionType.EditProfile,
        payload
    }
}

export function SharedDataWithCurrentUser(paylaod){
    return{
        type: ActionType.AllSharedData,
        paylaod
    }
}

export function authLinkedWithPoupDispatch(){
    return{
        type: ActionType.LinkedWithPopup
    }
}


// WEBPACK FOOTER //
// ./src/reducers/container/authDisptach.jsx